import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { routesList } from './pageRoutes';
import Unauthorised from '../commonComponents/unauthorised';

const Router = ({ user }) => {
    console.log(user);

    return (
        <Routes>
            {routesList
                ?.filter(d => {
                    if (d.skipAcl) return true;
                    const names = [d.title, d.aclName, ...(d.aclNames || [])];
                    return names.some(name => name && user?.components?.includes(name));
                })
                ?.map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        element={
                            route.provider ? (
                                <route.provider>
                                    <route.component />
                                </route.provider>
                            ) : (
                                <route.component />
                            )
                        }
                    />
                ))}
            <Route path="*" element={<Unauthorised />} />
        </Routes>
    );
};

export default Router;
